<script setup>
import SectionTitle from '@weathernews/btos-vuecomponent/with-onebox-common-elements/src/components/SectionTitle.vue'

const props = defineProps({
  title: {
    type: String,
    required: true
  },
  citycode: {
    type: String,
    required: true
  }
})

const config = useRuntimeConfig()
const listTitle = '周辺スポットの天気予報'
const { data: landmarkList } = await useFetch('/api/tenki/landmark', { query: { citycode: props.citycode } })
</script>

<template>
  <div
    v-if="landmarkList.length!==0"
    class="spotlist"
  >
    <SectionTitle :title="listTitle" />
    <ul class="block">
      <li
        v-for="point in landmarkList"
        :key="point.link"
      >
        <NuxtLink
          :to="`${config.public.hostDomain}${point.link}`"
          class="link"
          external
        >
          {{ point.name }}
        </NuxtLink>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
.spotlist {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .block {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 10px;
    border-radius: 6px;
    background-color: #eef1f8;
  }
  .link {
    display: flex;
    padding: 7px 10px;
    border-radius: 4px;
    background: #fff;
    box-shadow: 0 2px 4px #00000026;
    color: #303030;
    font-size: 13px;
    font-weight: 700;
    line-height: 13px;
    @media (any-hover: hover) {
      transition: box-shadow 0.2s ease-in-out;
      &:hover {
        box-shadow: 0 2px 6px #00000073;
      }
    }
  }
}
</style>
